const modalTypes = {
    PLUGGED_IN: 'PLUGGED_IN',
    PLUGGED_INTO: 'PLUGGED_INTO',
    CONVERSATION: 'CONVERSATION',
    SPINNUP_DISCOUNT_CODE: 'SPINNUP_DISCOUNT_CODE'
};

export default modalTypes;